import { render, staticRenderFns } from "./resultat-tdr.html?vue&type=template&id=03d3bdb3&scoped=true&external"
import script from "./resultat-tdr.js?vue&type=script&lang=js&external"
export * from "./resultat-tdr.js?vue&type=script&lang=js&external"
import style0 from "./resultat-tdr.scss?vue&type=style&index=0&id=03d3bdb3&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d3bdb3",
  null
  
)

export default component.exports